import tw from 'twin.macro';
import React from 'react';
import Label from '~/src/atoms/Label';
import Image from '~/src/atoms/Image';
import Carousel from '~/src/organisms/Carousel';
import Button from '~/src/atoms/Button';
import CaretDownSvg from '../../../public/bb2assets/images/svg/caret-down.svg';
import { motion, AnimatePresence } from 'framer-motion';

const OfferEntryPoint = ({ state = {}, Offercard = false, closeCommunicationPopUp = () => {}, fromPd = false }) => {
  const transformGradientColor = (respData, Parameters = '') => {
    const rgbaOrder = ['r', 'g', 'b', 'a'];
    switch (Parameters) {
      case 'OfferCardBg': {
        const GradientColorBuilder = respData?.card_bg?.style?.gradient?.map(function (color) {
          const obj = {};
          for (let i = 0; i < rgbaOrder.length; i++) {
            const key = rgbaOrder[i];
            obj[key] = color[key];
          }
          return obj;
        });
        const offerCardColor = GradientColorBuilder.map((data) => {
          const key = Object.keys(data).join(''),
            Value = Object.values(data).join(',');
          return callback(key, Value);
        });
        return `${respData.tag.style.orientation}(${offerCardColor.toString()})`;
      }
      default: {
        const GradientColorBuilder = respData?.tag?.style?.gradient?.map(function (color) {
          const obj = {};
          for (let i = 0; i < rgbaOrder.length; i++) {
            const key = rgbaOrder[i];
            obj[key] = color[key];
          }
          return obj;
        });
        const OfferTextColor = GradientColorBuilder.map((data) => {
          const key = Object.keys(data).join(''),
            Value = Object.values(data).join(',');
          return callback(key, Value);
        });
        OfferTextColor.shift();
        return `${respData.tag.style.orientation}(${OfferTextColor.toString()})`;
      }
    }
  };
  const callback = (a, b) => {
    const rbgastructure = `${a}(${b})`;
    return rbgastructure;
  };

  const AnimationProperty = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
    },
  };

  const renderCardView = (data) => {
    return (
      <AnimatePresence>
        {!fromPd && (
          <div css={tw`flex justify-end pr-0.5 pb-5`}>
            <Image
              onClick={() => closeCommunicationPopUp('close')}
              src={`${process.env.NEXT_PUBLIC_ASSETS_DOMAIN}/bb2assets/images/png/closecircle.png`}
              alt="OC_Image"
              width={24}
              height={24}
            />
          </div>
        )}
        <div
          css={tw`bg-cover rounded-xs bg-no-repeat lg:h-65.5 xl:h-78 pr-2.5 relative `}
          style={{
            backgroundPosition: 'center right',
            backgroundImage: `url(${data.card_bg.style.background.base_url}/${data.card_bg.style.background.image}.${
              data.card_bg.style.background.format
            }),${transformGradientColor(data, 'OfferCardBg')}`,
          }}>
          <div className="-mb-2.5 transform translate-x-2.5  -translate-y-4.5">
            <Image src={`${data.tag.style.icon.base_url}/${data.tag.style.icon.image}.${data.tag.style.icon.format}`} alt="OC_Image" width={40} height={40} />
          </div>
          <motion.div
            css={tw`rounded-r mb-2.5 relative  flex justify-start items-center lg:h-5 xl:h-5.5 overflow-hidden`}
            style={{ background: `${transformGradientColor(data)}` }}
            animate={{ width: Offercard ? '100%' : '50%' }}
            exit={{ width: '100%' }}
            transition={{ duration: 0.7, origin: 1 }}>
            <motion.span
              animate={{ x: Offercard ? 12 : -5 }}
              exit={{ x: 15 }}
              transition={{ duration: 1 }}
              css={tw`font-semibold absolute lg:text-sm xl:text-md leading-base`}
              style={data.tag.text.font}>
              {data.tag.text.value}
            </motion.span>
          </motion.div>
          <motion.div initial={AnimationProperty.initial} animate={AnimationProperty.animate} transition={{ duration: 2 }} css={tw`px-2.5 grid gap-y-1`}>
            <Label
              className={'font-bold text-darkOnyx-900 lg:text-base xl:text-lg'}
              style={data.details.offer_label.text.font}
              dangerouslySetInnerHTML={{
                __html: data.details.offer_label.text.value,
              }}
            />
            <Label
              css={tw`font-regular lg:text-sm xl:text-md lg:leading-xxs xl:leading-sm text-darkOnyx-500`}
              style={data.details.offer_desc.text.font}
              dangerouslySetInnerHTML={{
                __html: data.details.offer_desc.text.value,
              }}
            />
          </motion.div>
          <Label
            css={tw`font-regular absolute bottom-0 pb-5.5 lg:text-xs px-2.5 xl:text-sm leading-xxs`}
            style={data.details.tnc.text.font}
            dangerouslySetInnerHTML={{ __html: data.details.tnc.text.value }}
          />
        </div>
      </AnimatePresence>
    );
  };

  const CarouselPrevControlEvent = (e, prev, desired) => {
    if (desired !== 0) {
      return prev();
    } else {
      return e.preventDefault();
    }
  };

  const CarouselNexControlEvent = (e, next, desired, state) => {
    if (desired != state.length - 1) {
      return next();
    } else {
      return e.preventDefault();
    }
  };

  return (
    <Carousel layout="horizontal" dragDisabled={true} css={tw`relative  xl:w-61.5 lg:w-48.5 overflow-hidden`} interval={0}>
      {state?.data?.map((resData, index) => {
        return <Carousel.Slide key={index}>{renderCardView(resData)}</Carousel.Slide>;
      })}
      <Carousel.Control>
        {({ next, prev, jump, desired }) => (
          <div css={tw`grid grid-flow-col pt-1 px-0.5 pb-4.5`}>
            {state?.data?.length >= 2 && (
              <Button
                onClick={(e) => CarouselPrevControlEvent(e, prev, desired)}
                css={tw`w-5 h-5 px-1.5 py-1 my-0.5 bg-darkOnyx-400 shadow-2 rounded-full bottom-0 border-none`}
                aria-label="Left">
                <CaretDownSvg css={tw`stroke-current stroke-2 text-white transform rotate-90`} />
              </Button>
            )}
            <div className="h-6 w-full p-2.5 grid grid-flow-col place-content-center justify-items-center gap-x-2">
              {state?.data?.map(({ id }, index) => (
                <div
                  key={id}
                  onClick={() => jump(index)}
                  css={[
                    tw`h-1.5 w-1.5  rounded-full cursor-pointer`,
                    desired === index ? tw`transform scale-150 bg-darkOnyx-400` : tw`bg-silverSurfer-400`,
                  ]}></div>
              ))}
            </div>
            {state?.data?.length >= 2 && (
              <Button
                onClick={(e) => CarouselNexControlEvent(e, next, desired, state.data)}
                css={tw`w-5 justify-self-end h-5  my-0.5 px-1.5 py-1 right-0  bg-darkOnyx-400 shadow-2   rounded-full border-none bottom-0`}
                aria-label="Right">
                <CaretDownSvg css={tw`stroke-current stroke-2 text-white transform -rotate-90`} />
              </Button>
            )}
          </div>
        )}
      </Carousel.Control>
    </Carousel>
  );
};

export default OfferEntryPoint;
